export async function parseApiJson(response) {
  const text = await response.text();
  const trimmed = text.trimStart();
  if (!trimmed) {
    return null;
  }
  if (trimmed.startsWith("<!") || trimmed.startsWith("<")) {
    throw new Error(
      "The app received a web page instead of API data. In frontend/.env set REACT_APP_API_URL=http://localhost:5000 (your Express backend), not http://localhost:3000. Ensure the backend is running (npm run dev:api)."
    );
  }
  try {
    return JSON.parse(text);
  } catch (parseError) {
    throw new Error(parseError?.message ? `Invalid JSON: ${parseError.message}` : "Invalid JSON from server.");
  }
}
